/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';
import { getTotalFromSimulation, runSimulation } from '../components/utils/creditSimulation';

const useDownpaymentData= () => {
    const [state, setState] = useContext(CotizadorContext)

    const setDownPaymentPercentage = async downpayment_percentage => {
        let simulation = null;

        if (state.selected_car) {
            document.getElementById('cotizador_overlay').style.display = 'block';
            const simulationResult = await runSimulation(state.selected_car, state.selected_time, state.selected_distance, downpayment_percentage);
            
            if (!simulationResult.success) {
                console.error('[useDownpaymentData] Error en simulación:', simulationResult.error);
                // Mostrar error al usuario con notificación pero PERMITIR el cambio de pie
                const newState = {
                    downpayment_percentage,
                    error_notification: simulationResult.error,
                    simulation_results: null,
                    simulation_total: 0
                };
                
                setState(prevState => ({
                    ...prevState,
                    ...newState
                }));
                document.getElementById('cotizador_overlay').style.display = 'none';
                return;
            }
            
            simulation = simulationResult.data;
            
            const newState = {
                downpayment_percentage,
                simulation_results: simulation,
                simulation_total: getTotalFromSimulation(simulation),
                simulation_error: null
            };
            
            setState(prevState => ({
                ...prevState,
                ...newState
            }))
        } else {
            setState(prevState => ({
                ...prevState,
                downpayment_percentage
            }))
        }

        
        document.getElementById('cotizador_overlay').style.display = 'none';
    }

    return {
        downpayment_percentage: state.downpayment_percentage,
        setDownPaymentPercentage,
    };
}

export default useDownpaymentData;